import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, forwardRef, Component, Injectable, QueryList, ContentChildren, Optional, HostBinding, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { RovingTabindex, TabbableOption } from '@anthem/uxd/util';

//istanbul ignore next
class RadioButtonDirective {
    constructor(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.ngOnChangeRun = false;
        this.ngModelChange = new EventEmitter(false);
        this.onChange = new EventEmitter(false);
    }
    ngOnInit() {
        //TODO:
    }
    ngAfterViewInit() {
        if (!this._element.nativeElement.id) {
            console.error('RadiobuttonDirective id missing !!!');
        }
        else if (!this._element.nativeElement.name) {
            console.error('RadiobuttonDirective name missing !!!');
        }
        if (this._element.nativeElement.nextElementSibling.tagName.toLowerCase() !== 'label') {
            console.error('RadiobuttonDirective label missing !!!');
        }
        this._renderer.addClass(this._element.nativeElement, 'prOption');
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'prLabel');
        if (this._modelValue) {
            this.ngOnChanges({ _modelValue: { currentValue: this._modelValue } }, true);
            this.ngOnChangeRun = false;
        }
    }
    ngOnChanges(changes, setCss = false) {
        if (!this._element.nativeElement.nextElementSibling) {
            return;
        }
        this.ngOnChangeRun = true;
        if (typeof changes['_modelValue'] !== 'undefined' && changes['_modelValue'].currentValue && changes['_modelValue'].currentValue.toString() === this._element.nativeElement.defaultValue) {
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
        else {
            if (this._element.nativeElement.nextElementSibling) {
                this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'active');
            }
        }
    }
    onFocus() {
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    onBlur() {
        this._renderer.removeClass(this._element.nativeElement.nextElementSibling, 'focus');
    }
    onClick() {
        if (typeof this.isOptional !== 'undefined' &&
            this._element.nativeElement.nextElementSibling.classList.contains('active') &&
            this.isOptional &&
            ((!window.isSafari && !window.isIE) || !this.ngOnChangeRun)) {
            this.ngModelChange.emit('');
        }
        else {
            this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'active');
            this.ngModelChange.emit(this._element.nativeElement.defaultValue);
        }
        this.ngOnChangeRun = false;
        this._renderer.addClass(this._element.nativeElement.nextElementSibling, 'focus');
        this.onChange.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioButtonDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: RadioButtonDirective, selector: "[data-uxd-radio-dir]", inputs: { _modelValue: ["ngModel", "_modelValue"], isOptional: ["optional", "isOptional"] }, outputs: { ngModelChange: "ngModelChange", onChange: "onChange" }, host: { listeners: { "focus": "onFocus()", "blur": "onBlur()", "click": "onClick()" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-radio-dir]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { _modelValue: [{
                type: Input,
                args: ['ngModel']
            }], ngModelChange: [{
                type: Output
            }], isOptional: [{
                type: Input,
                args: ['optional']
            }], onChange: [{
                type: Output,
                args: ['onChange']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

//istanbul ignore next
class RadioInputComponent {
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    constructor(_renderer) {
        this._renderer = _renderer;
        this.definition = {
            id: '',
            label: '',
            name: '',
            value: '',
            ariaLabel: ''
        };
        this.isSelected = false;
        this.isFocused = false;
    }
    ngAfterViewInit() {
        //noop
    }
    ngOnChanges(changes) {
        //noop
    }
    onItemClick() {
        this.isSelected = true;
        this._onChangeCallback(this.definition.value);
    }
    onItemFocus() {
        this.isFocused = true;
    }
    onItemBlur() {
        this.isFocused = false;
        this._onTouchedCallback();
    }
    writeValue(v) {
        if (typeof v !== 'undefined' && typeof this.definition.value !== 'undefined' && v !== null && this.definition.value !== null && v.toString() === this.definition.value.toString()) {
            this.isSelected = true;
        }
        else {
            this.isSelected = false;
        }
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        //todo
        this._onTouchedCallback = fn;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioInputComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RadioInputComponent, selector: "[data-uxd-radio-input-cmp]", inputs: { definition: "definition" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioInputComponent),
                multi: true
            }
        ], usesOnChanges: true, ngImport: i0, template: `<input (focus)="onItemFocus()" (blur)="onItemBlur()" (click)="onItemClick()" [checked]="isSelected" class="prOption" type="radio" [name]="definition.name" [id]="definition.id" [value]="definition.value" [attr.value]="definition.value" />
             <label [attr.aria-label]="definition.ariaLabel" [class.focus]="isFocused" [id]="'lbl_'+definition.id" [class.active]="isSelected"  class="prLabel" [attr.for]="definition.id" [innerHTML]="definition.label" [attr.data-analytics] = "definition.analyticsText"></label>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-radio-input-cmp]',
                    template: `<input (focus)="onItemFocus()" (blur)="onItemBlur()" (click)="onItemClick()" [checked]="isSelected" class="prOption" type="radio" [name]="definition.name" [id]="definition.id" [value]="definition.value" [attr.value]="definition.value" />
             <label [attr.aria-label]="definition.ariaLabel" [class.focus]="isFocused" [id]="'lbl_'+definition.id" [class.active]="isSelected"  class="prLabel" [attr.for]="definition.id" [innerHTML]="definition.label" [attr.data-analytics] = "definition.analyticsText"></label>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => RadioInputComponent),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { definition: [{
                type: Input
            }] } });

//istanbul ignore next
class RadioInputGroupComponent {
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    constructor(_renderer) {
        this._renderer = _renderer;
        this.radioGroup = {
            id: '',
            name: '',
            label: '',
            ariaLabel: '',
            options: [],
            isOptional: false,
            legendSrOnly: false,
            showLegendAsLbl: false,
            alignVertical: false,
            templateRef: undefined
        };
        this.optionalSelected = false;
        this.disabled = false;
        this.onInputFocus = new EventEmitter();
    }
    ngAfterViewInit() {
        //noop
    }
    ngOnChanges(changes) {
        //noop
    }
    onItemClick(item) {
        if (item.isSelected && this.radioGroup.isOptional) {
            this.onOptionalFocus();
        }
        else {
            this.setSelectedValue(item.value);
            this._onChangeCallback(item.value);
        }
    }
    onOptionalFocus() {
        this.optionalSelected = true;
        this.setSelectedValue('');
        this._onChangeCallback('');
    }
    onItemFocus(item) {
        item.isFocused = true;
        this.onInputFocus.emit(item);
    }
    onItemBlur(item) {
        item.isFocused = false;
        this._onTouchedCallback();
    }
    writeValue(v) {
        this.setSelectedValue(v);
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        //todo
        this._onTouchedCallback = fn;
    }
    setSelectedValue(value = '') {
        value = value === null || typeof value === 'undefined' ? '' : value;
        this.optionalSelected = false;
        this.radioGroup.options.forEach((item) => {
            if (item.value.toString() === value.toString()) {
                item.isSelected = true;
            }
            else {
                item.isSelected = false;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioInputGroupComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RadioInputGroupComponent, selector: "[data-uxd-radio-input-group-cmp]", inputs: { radioGroup: "radioGroup", disabled: "disabled" }, outputs: { onInputFocus: "onInputFocus" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioInputGroupComponent),
                multi: true
            }
        ], usesOnChanges: true, ngImport: i0, template: ` <fieldset class="pfRadio">
                <legend [id]="'lgnd_'+radioGroup.id" class="" [class.ant-span-label]="radioGroup.showLegendAsLbl" [class.sr-only]="radioGroup.legendSrOnly" [innerHTML]="radioGroup.label"></legend>
                  <div [class.align-vertical]="radioGroup.alignVertical">
                  <ng-container *ngFor="let o of radioGroup.options; let pIdx = index;">
                    <input [attr.aria-label]="o.ariaLabel" (focus)="onItemFocus(o)" (blur)="onItemBlur(o)" (click)="onItemClick(o)" [checked]="o.isSelected" class="prOption" type="radio" [name]="radioGroup.name" [id]="radioGroup.id+pIdx" [value]="o.value" [attr.value]="o.value" [attr.data-analytics] = "o.analytics"/>
                    <ng-container *ngIf="!radioGroup.templateRef">
                      <label [class.focus]="o.isFocused" [class.disabled]="disabled" [id]="'lbl_'+radioGroup.id+pIdx" [class.active]="o.isSelected"  class="prLabel" [attr.for]="radioGroup.id+pIdx" [innerHTML]="o.label" [attr.data-analytics] = "o.analyticsText"></label>
                    </ng-container>
                    <ng-container *ngIf="radioGroup.templateRef">
                      <label [class.focus]="o.isFocused" [id]="'lbl_'+radioGroup.id+pIdx" [class.active]="o.isSelected"  class="prLabel" [attr.for]="radioGroup.id+pIdx" [attr.data-analytics] = "o.analyticsText">
                        <ng-container *ngTemplateOutlet="radioGroup.templateRef; context: {context: o.context}"></ng-container>
                      </label>
                    </ng-container>
                  </ng-container>
                  </div>
                  <input class="sr-only" [disabled]="disabled" *ngIf="radioGroup.isOptional" (focus)="onOptionalFocus()" [checked]="optionalSelected" class="prOption" type="radio" [name]="radioGroup.name" [id]="radioGroup.id+'_opt'" [value]="" [attr.value]="" />
              </fieldset>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioInputGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-radio-input-group-cmp]',
                    template: ` <fieldset class="pfRadio">
                <legend [id]="'lgnd_'+radioGroup.id" class="" [class.ant-span-label]="radioGroup.showLegendAsLbl" [class.sr-only]="radioGroup.legendSrOnly" [innerHTML]="radioGroup.label"></legend>
                  <div [class.align-vertical]="radioGroup.alignVertical">
                  <ng-container *ngFor="let o of radioGroup.options; let pIdx = index;">
                    <input [attr.aria-label]="o.ariaLabel" (focus)="onItemFocus(o)" (blur)="onItemBlur(o)" (click)="onItemClick(o)" [checked]="o.isSelected" class="prOption" type="radio" [name]="radioGroup.name" [id]="radioGroup.id+pIdx" [value]="o.value" [attr.value]="o.value" [attr.data-analytics] = "o.analytics"/>
                    <ng-container *ngIf="!radioGroup.templateRef">
                      <label [class.focus]="o.isFocused" [class.disabled]="disabled" [id]="'lbl_'+radioGroup.id+pIdx" [class.active]="o.isSelected"  class="prLabel" [attr.for]="radioGroup.id+pIdx" [innerHTML]="o.label" [attr.data-analytics] = "o.analyticsText"></label>
                    </ng-container>
                    <ng-container *ngIf="radioGroup.templateRef">
                      <label [class.focus]="o.isFocused" [id]="'lbl_'+radioGroup.id+pIdx" [class.active]="o.isSelected"  class="prLabel" [attr.for]="radioGroup.id+pIdx" [attr.data-analytics] = "o.analyticsText">
                        <ng-container *ngTemplateOutlet="radioGroup.templateRef; context: {context: o.context}"></ng-container>
                      </label>
                    </ng-container>
                  </ng-container>
                  </div>
                  <input class="sr-only" [disabled]="disabled" *ngIf="radioGroup.isOptional" (focus)="onOptionalFocus()" [checked]="optionalSelected" class="prOption" type="radio" [name]="radioGroup.name" [id]="radioGroup.id+'_opt'" [value]="" [attr.value]="" />
              </fieldset>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => RadioInputGroupComponent),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { radioGroup: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onInputFocus: [{
                type: Output
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class ExclusiveSelectService {
    constructor() {
        this._listeners = [];
    }
    notify(item, name) {
        for (const listener of this._listeners) {
            listener(item, name);
        }
    }
    listen(listener) {
        this._listeners.push(listener);
    }
    ngOnDestroy() {
        this._listeners = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectService, decorators: [{
            type: Injectable
        }] });

/** Used to generated unique HTML IDs. */
let radioItemID = 0;
let fieldsetId = 0;
class ExclusiveSelectFieldsetDirective {
    get value() {
        return this._value;
    }
    /** Returns the readonly HTML Id defined earlier. */
    get id() {
        return this._uniqueID;
    }
    /** Emits a boolean value to all subscribed toggle items. */
    _toggleSelectionAll(isChecked) {
        this._selectionStream.next(isChecked);
    }
    constructor(_exclusiveSelectObserver) {
        this._exclusiveSelectObserver = _exclusiveSelectObserver;
        this._selectionStream = new Subject();
        // Function to call when the rating changes.
        // tslint:disable-next-line: no-empty
        this.onChange = (value) => { };
        // Function to call when the input is touched (when a star is clicked).
        // tslint:disable-next-line: no-empty
        this.onTouched = () => { };
        this.disabled = false;
        this._options = new QueryList();
        this._uniqueID = `uxd-select-fieldset-${fieldsetId++}`;
        this.selected = new EventEmitter();
        this._exclusiveSelectObserver.listen((selected) => {
            selected.select(false);
            this.writeValue(selected.value);
            this.selected.emit(selected.value);
        });
    }
    ngAfterViewInit() {
        if (this._options) {
            this._keyboardManager = new RovingTabindex(this._options);
            this._keyboardManager.change.subscribe((option) => {
                option.select(true);
            });
            if (this._isNoOptionSelected()) {
                // Ensure that at least one option is tabbable.
                this._options.first.isFocusable = true;
            }
        }
    }
    // Allows Angular to update the model (selected value).
    // Update the model and changes needed for the view here.
    writeValue(value) {
        if (value === null) {
            this.clear();
            return;
        }
        this._value = value;
        this.selectByValue(value);
        this.onChange(value);
    }
    // Allows Angular to register a function to call when the model (selected value) changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    handleKeydown(event) {
        this._keyboardManager.handleKeyboard(event);
    }
    /** Remove any set value, and apply focus to the first option. */
    clear() {
        this._value = null;
        this.onChange(null);
        this._toggleSelectionAll(false);
        if (this._options && this._options.length) {
            this._options.first.isFocusable = true;
        }
    }
    /**
     * Check whether an option is selected.
     * By default, when a radio group is initialized, no option is selected.
     */
    _isNoOptionSelected() {
        const options = this._options.toArray();
        if (!options || !options.length) {
            return false;
        }
        return options.every((option) => !option.isChecked);
    }
    selectByValue(value) {
        const options = this._options.toArray();
        if (options && options.length) {
            const opts = options.filter((option) => value === option.value);
            if (!opts || !opts.length) {
                throw new Error(`No ExclusiveSelectToggleDirective found with value "${value}"`);
            }
            const optToSelect = opts[0];
            optToSelect.select(false);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectFieldsetDirective, deps: [{ token: ExclusiveSelectService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ExclusiveSelectFieldsetDirective, selector: "[uxd-select]", inputs: { disabled: "disabled" }, outputs: { selected: "selected" }, host: { attributes: { "role": "radiogroup" }, listeners: { "keydown": "handleKeydown($event)" } }, providers: [
            ExclusiveSelectService,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ExclusiveSelectFieldsetDirective),
                multi: true
            }
        ], queries: [{ propertyName: "_options", predicate: i0.forwardRef(function () { return ExclusiveSelectToggleDirective; }) }], exportAs: ["RadioFieldset"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectFieldsetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[uxd-select]",
                    exportAs: "RadioFieldset",
                    host: {
                        role: "radiogroup"
                    },
                    providers: [
                        ExclusiveSelectService,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ExclusiveSelectFieldsetDirective),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: ExclusiveSelectService }]; }, propDecorators: { disabled: [{
                type: Input
            }], _options: [{
                type: ContentChildren,
                args: [forwardRef(() => ExclusiveSelectToggleDirective)]
            }], selected: [{
                type: Output
            }], handleKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });
class ExclusiveSelectToggleDirective extends TabbableOption {
    set isChecked(value) {
        if (this._isChecked !== value) {
            this._isChecked = value;
        }
        /* Finally —
          * Inform Angular that values have changed, and that the
          * the template needs to be re-rendered to reflect those changes. */
        this._changeDetectorRef.detectChanges();
    }
    get isChecked() {
        return this._isChecked;
    }
    /** Returns the readonly HTML Id defined earlier. */
    get id() {
        return this._uniqueID;
    }
    _subscribeToSelectionStream() {
        return this.radioSelectGroup._selectionStream.subscribe((isChecked) => {
            this._isChecked = isChecked;
            this._changeDetectorRef.detectChanges();
        });
    }
    constructor(radioSelectGroup, _element, _exclusiveSelectObserver, _changeDetectorRef) {
        super(_element);
        this._element = _element;
        this._exclusiveSelectObserver = _exclusiveSelectObserver;
        this._changeDetectorRef = _changeDetectorRef;
        /** A reference to the observable stream declared in the parent accordion,
         * which emits true/false whenever openAll/closeAll methods have been called.*/
        this._selectionSubscription = Subscription.EMPTY;
        this._uniqueID = `uxd-select-item-${radioItemID++}`;
        this.change = new EventEmitter();
        this._isChecked = false;
        // By default, make the option non-tabbable.
        // This is a key part of how the roving "tabindex" works.
        this.isFocusable = false;
        this.radioSelectGroup = radioSelectGroup;
        _exclusiveSelectObserver.listen((item, radioId) => {
            if (!this.radioSelectGroup) {
                return;
            }
            /* Ensure that the parent fieldset is the same fieldset that contained the change,
            * and that this item was not the source of the change. */
            if (this.radioSelectGroup.id === radioId && item.id !== this.id) {
                this.deselect(); // Deselect the radio
            }
            if (radioSelectGroup && radioSelectGroup._selectionStream) {
                this._selectionSubscription = this._subscribeToSelectionStream();
            }
        });
    }
    ngOnDestroy() {
        this._selectionSubscription.unsubscribe();
    }
    handleClick(event) {
        this.select();
    }
    _emitChangeEvent() {
        this.change.emit(this._isChecked);
    }
    /** Select the toggle item, making it checked. */
    select(isUserAction = true) {
        this.isChecked = true;
        if (this.isChecked && this.radioSelectGroup && isUserAction) {
            this._exclusiveSelectObserver.notify(this, this.radioSelectGroup.id);
            this._emitChangeEvent();
        }
    }
    toggle(isUserAction = true) {
        this.isChecked = !this._isChecked;
        if (this.isChecked && this.radioSelectGroup && isUserAction) {
            this._exclusiveSelectObserver.notify(this, this.radioSelectGroup.id);
        }
    }
    /** Deselect the toggle */
    deselect() {
        this.isChecked = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectToggleDirective, deps: [{ token: ExclusiveSelectFieldsetDirective, optional: true }, { token: i0.ElementRef }, { token: ExclusiveSelectService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ExclusiveSelectToggleDirective, selector: "[uxd-select-toggle]", inputs: { value: "value" }, outputs: { change: "change" }, host: { attributes: { "role": "radio" }, listeners: { "click": "handleClick($event)" }, properties: { "attr.checked": "this.isChecked", "attr.aria-checked": "this.isChecked", "class.is-checked": "this.isChecked" }, classAttribute: "uxd-exclusive-toggle" }, exportAs: ["RadioToggle"], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExclusiveSelectToggleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[uxd-select-toggle]",
                    exportAs: "RadioToggle",
                    host: {
                        role: "radio",
                        class: "uxd-exclusive-toggle"
                    }
                }]
        }], ctorParameters: function () { return [{ type: ExclusiveSelectFieldsetDirective, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: ExclusiveSelectService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { change: [{
                type: Output
            }], value: [{
                type: Input
            }], isChecked: [{
                type: HostBinding,
                args: ["attr.checked"]
            }, {
                type: HostBinding,
                args: ["attr.aria-checked"]
            }, {
                type: HostBinding,
                args: ["class.is-checked"]
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class RadioModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RadioModule, declarations: [RadioButtonDirective, RadioInputComponent, RadioInputGroupComponent, ExclusiveSelectToggleDirective, ExclusiveSelectFieldsetDirective], imports: [CommonModule], exports: [RadioButtonDirective, RadioInputComponent, RadioInputGroupComponent, ExclusiveSelectToggleDirective, ExclusiveSelectFieldsetDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [RadioButtonDirective, RadioInputComponent, RadioInputGroupComponent, ExclusiveSelectToggleDirective, ExclusiveSelectFieldsetDirective],
                    exports: [RadioButtonDirective, RadioInputComponent, RadioInputGroupComponent, ExclusiveSelectToggleDirective, ExclusiveSelectFieldsetDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ExclusiveSelectFieldsetDirective, ExclusiveSelectService, ExclusiveSelectToggleDirective, RadioButtonDirective, RadioInputComponent, RadioInputGroupComponent, RadioModule };
